import React, { useState } from "react";
import { X } from "lucide-react";

const SeasonModal = ({ season, coachEras, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    year: season?.year || '',
    title: season?.title || '',
    coach_era_id: season?.coach_era_id || '',
    coach_era_name: season?.coach_era_name || '',
    description: season?.description || '',
    thumbnail: season?.thumbnail || ''
  });
  
  const handleEraChange = (eraId) => {
    const era = coachEras?.find(e => e.id === eraId);
    setFormData({
      ...formData,
      coach_era_id: eraId,
      coach_era_name: era?.name || ''
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{season ? 'Edit Season' : 'Add Season'}</h2>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {!season && (
              <div className="form-group">
                <label className="form-label">Coach Era *</label>
                <select
                  className="form-select"
                  value={formData.coach_era_id}
                  onChange={(e) => handleEraChange(e.target.value)}
                  required
                  data-testid="season-era-select"
                >
                  <option value="">Select Coach Era</option>
                  {coachEras?.map((era) => (
                    <option key={era.id} value={era.id}>{era.coach_name} ({era.years})</option>
                  ))}
                </select>
              </div>
            )}
            
            <div className="form-group">
              <label className="form-label">Year *</label>
              <input
                type="text"
                className="form-input"
                value={formData.year}
                onChange={(e) => setFormData({ ...formData, year: e.target.value })}
                placeholder="e.g., 2023-24"
                required
                data-testid="season-year-input"
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">Title *</label>
              <input
                type="text"
                className="form-input"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                placeholder="e.g., 2023-24 Season"
                required
                data-testid="season-title-input"
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">Description</label>
              <textarea
                className="form-textarea"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                placeholder="Season description..."
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">Thumbnail URL</label>
              <input
                type="text"
                className="form-input"
                value={formData.thumbnail}
                onChange={(e) => setFormData({ ...formData, thumbnail: e.target.value })}
                placeholder="https://..."
              />
            </div>
          </div>
          
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" data-testid="save-season-btn">
              {season ? 'Update' : 'Create'} Season
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SeasonModal;
